/* ==========================================================================
   Papaking theme — 前端交互
   原则：购物车与结账走 Shopify 原生表单，JS 只做增强，
   禁用 JS 时所有功能仍可用（表单直接 POST）。
   ========================================================================== */

(function () {
  'use strict';

  /* ── 移动端导航 ─────────────────────────────────────────── */

  var burger = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-nav-mobile]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.hidden = !mobileNav.hidden;
      burger.setAttribute('aria-expanded', String(!mobileNav.hidden));
    });
  }

  /* ── toast 提示 ─────────────────────────────────────────── */

  var toastEl = null;
  var toastTimer = null;

  function toast(message, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.className = 'toast' + (opts.error ? ' toast--error' : '');
    toastEl.innerHTML = '';

    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);

    if (opts.linkHref) {
      var a = document.createElement('a');
      a.href = opts.linkHref;
      a.textContent = opts.linkText || 'View';
      toastEl.appendChild(a);
    }

    // 强制重排，保证 transition 触发
    void toastEl.offsetWidth;
    toastEl.setAttribute('data-show', 'true');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.setAttribute('data-show', 'false');
    }, opts.duration || 4000);
  }

  /* ── 购物车角标 ─────────────────────────────────────────── */

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* 角标更新失败不影响主流程 */ });
  }

  /* ── 快速加购（商品卡上的 Add 按钮） ──────────────────── */

  document.querySelectorAll('form[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // 无 fetch 支持时退回原生表单提交
      if (!window.fetch) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '···'; }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/javascript' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          toast('Added to cart', { linkHref: '/cart', linkText: 'View cart' });
          return refreshCartCount();
        })
        .catch(function (err) {
          toast(err.message || 'Could not add to cart', { error: true });
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* ── 商品页 ─────────────────────────────────────────────── */

  var pForm = document.querySelector('[data-product-form]');
  if (pForm) {
    /* 数量加减 */
    var qtyInput = pForm.querySelector('[data-qty-input]');
    var down = pForm.querySelector('[data-qty-down]');
    var up = pForm.querySelector('[data-qty-up]');
    if (qtyInput) {
      if (down) down.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (up) up.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    /* 变体选择：支持 select 下拉 + 旧版 button 兼容 */
    var dataEl = pForm.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var idInput = pForm.querySelector('[data-variant-id]');
    var addBtn = pForm.querySelector('[data-add-btn]');
    var priceEl = document.querySelector('[data-price]');
    var instEl = document.querySelector('[data-installments]');
    var galleryMain = document.querySelector('[data-gallery-main]');

    function getGroupSelect(group) {
      return group.querySelector('select[data-option-select]') || group.querySelector('select');
    }

    function currentSelection() {
      return Array.prototype.map.call(
        pForm.querySelectorAll('[data-option-index]'),
        function (group) {
          var sel = getGroupSelect(group);
          if (sel) return sel.value || null;
          var active = group.querySelector('.opt[aria-pressed="true"]');
          return active ? active.getAttribute('data-option-value') : null;
        }
      );
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* 标记不可用的选项组合（select option + 旧版 button） */
    function markUnavailable() {
      var sel = currentSelection();
      pForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var selectEl = getGroupSelect(group);
        if (selectEl) {
          Array.prototype.forEach.call(selectEl.options, function (opt) {
            if (!opt.value) return;
            var probe = sel.slice();
            probe[idx] = opt.value;
            var v = findVariant(probe);
            opt.disabled = !v || !v.available;
          });
        }
        group.querySelectorAll('.opt').forEach(function (opt) {
          var probe = sel.slice();
          probe[idx] = opt.getAttribute('data-option-value');
          var v = findVariant(probe);
          opt.setAttribute('data-unavailable', String(!v || !v.available));
        });
      });
    }

    function formatMoney(cents) {
      // Shopify 的 money 格式在服务端渲染；此处只做简单回退
      return '$' + (cents / 100).toFixed(2);
    }

    function onSelect() {
      var sel = currentSelection();
      var v = findVariant(sel);
      markUnavailable();

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      if (priceEl) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s>' + formatMoney(v.compare_at_price) + '</s> ';
        }
        html += formatMoney(v.price);
        priceEl.innerHTML = html;
      }

      /* 同步 4 期免息金额 */
      if (instEl && v.price) {
        var q = v.price / 4;
        instEl.innerHTML = 'or 4 interest-free payments of <b>' + formatMoney(q) + '</b> with Shop Pay ' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-label="info"><circle cx="12" cy="12" r="9"/><path d="M12 8v.01M11 12h1v4h1"/></svg>';
      }

      if (v.featured_image && galleryMain) {
        var img = galleryMain.querySelector('img');
        if (img) img.src = v.featured_image;
      }

      // 同步 URL，便于分享具体变体
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* select 模式：change 事件 */
    pForm.querySelectorAll('select[data-option-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var group = sel.closest('[data-option-index]');
        var label = group ? group.querySelector('[data-option-selected]') : null;
        if (label) label.textContent = sel.value || '-- Please Select --';
        onSelect();
      });
    });

    /* 旧版 button 模式（向下兼容） */
    pForm.querySelectorAll('[data-option-index]').forEach(function (group) {
      if (getGroupSelect(group)) return;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt');
        if (!btn) return;
        group.querySelectorAll('.opt').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var label = group.querySelector('[data-option-selected]');
        if (label) label.textContent = btn.getAttribute('data-option-value');
        onSelect();
      });
    });

    if (variants.length) markUnavailable();

    /* 商品页加购 —— 同样走 fetch 增强 */
    pForm.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      if (e.submitter && e.submitter.name !== 'add') return;
      e.preventDefault();

      var original = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding···'; }

      fetch('/cart/add', {
        method: 'POST',
        body: new FormData(pForm),
        headers: { Accept: 'application/javascript' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          toast('Added to cart', { linkHref: '/cart', linkText: 'View cart' });
          return refreshCartCount();
        })
        .catch(function (err) {
          toast(err.message || 'Could not add to cart', { error: true });
        })
        .finally(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = original; }
        });
    });
  }

  /* ── 商品图库缩略图切换 ─────────────────────────────────── */

  var thumbs = document.querySelector('[data-gallery-thumbs]');
  var main = document.querySelector('[data-gallery-main]');
  if (thumbs && main) {
    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('.gallery__thumb');
      if (!t) return;
      thumbs.querySelectorAll('.gallery__thumb').forEach(function (x) {
        x.setAttribute('aria-current', 'false');
      });
      t.setAttribute('aria-current', 'true');
      var full = t.getAttribute('data-full');
      var img = main.querySelector('img');
      if (full && img) img.src = full;
    });
  }

  /* ── 购物车数量输入自动提交 ─────────────────────────────── */

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.querySelector('[name="update"]').click();
    });
  });

  /* ── Wishlist（localStorage） ─────────────────────────── */

  var wishKey = 'papaking:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(wishKey) || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(arr) {
    try { localStorage.setItem(wishKey, JSON.stringify(arr)); } catch (e) {}
  }

  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    var handle = btn.getAttribute('data-product-handle');
    var list = getWishlist();
    var tEl = btn.querySelector('[data-wishlist-text]');
    if (list.indexOf(handle) !== -1) {
      btn.setAttribute('data-active', 'true');
      if (tEl) tEl.textContent = 'In wish list';
    }
    btn.addEventListener('click', function () {
      var cur = getWishlist();
      var i = cur.indexOf(handle);
      if (i === -1) {
        cur.push(handle);
        btn.setAttribute('data-active', 'true');
        if (tEl) tEl.textContent = 'In wish list';
        toast('Added to wish list');
      } else {
        cur.splice(i, 1);
        btn.removeAttribute('data-active');
        if (tEl) tEl.textContent = 'Add to wish list';
        toast('Removed from wish list');
      }
      saveWishlist(cur);
    });
  });
})();
